import { useState } from 'react';
import { useSesion } from '../sesion';

export function Ingreso() {
  const { ingresar } = useSesion();
  const [email, setEmail] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setEnviando(true);
    try {
      await ingresar(email, clave);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo iniciar sesión.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <form className="login" onSubmit={enviar}>
      <h1>Conciliación de Tarjetas</h1>
      <p className="sub">MULTIEMPRESAS</p>

      <label htmlFor="email">Email</label>
      <input id="email" type="email" value={email} autoComplete="username"
             onChange={(e) => setEmail(e.target.value)} required autoFocus />

      <label htmlFor="clave">Contraseña</label>
      <input id="clave" type="password" value={clave} autoComplete="current-password"
             onChange={(e) => setClave(e.target.value)} required />

      {error && <div className="aviso bad" role="alert" style={{ marginTop: 16 }}>{error}</div>}

      <button className="btn-run" type="submit" disabled={enviando}>
        {enviando ? 'Verificando…' : 'Entrar'}
      </button>
    </form>
  );
}
